import styled from 'styled-components';
import { ReactComponent as Back } from '../../assets/icons/back-icon-mobile.svg';

export const IconBack = styled(Back)`
  display: flex;
  width: 24px;
  height: 24px;

  @media (min-width: 960px) {
    display: none;
  }
  :hover {
    cursor: pointer;
  }
`;

export const DebtsRoot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .content {
    width: 100%;
    padding: 24px 20px;

    @media (min-width: 960px) {
      width: 624px;
      padding-bottom: 28px;
      margin-top: 40px;
    }
  }

  .section-cards {
    margin-top: 28px;
    @media (min-width: 960px) {
      margin-top: 32px;
    }
  }

  .footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
  }

  .sub-title {
    font-family: ${(props) => props.theme.primaryFont};
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    color: #222222;
    margin-bottom: 20px;

    @media (min-width: 960px) {
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 16px;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;

  .title {
    font-family: ${(props) => props.theme.primaryFont};
    font-style: normal;
    font-weight: bold;
    color: #070c2f;
    margin-left: 8px;
    font-size: 24px;
    line-height: 30px;

    @media (min-width: 960px) {
      margin-left: 0;
      font-size: 28px;
      line-height: 35px;
    }
  }

  .step-title {
    font-family: ${(props) => props.theme.primaryFont};
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    text-transform: uppercase;
    color: #222222;
  }

  .sub-section-header {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 30px;

    @media (min-width: 960px) {
      justify-content: space-between;
    }
  }

  .title-section-header {
    display: flex;
    align-items: center;
    margin-right: 28px;
  }

  .step-counter {
    display: none;
    @media (min-width: 960px) {
      display: contents;
    }
  }

  .step-counter-mobile {
    display: contents;
    @media (min-width: 960px) {
      display: none;
    }
  }
`;
